import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { CommonErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { LensContentType } from '../models/ContentTypes';
import { ILensBase } from '../models/ILensInfo';
import { ContentUrlForItem } from './ContentUrl';

export class LensErrors {
  public static errorDetailsFor(LensErrorItem: IErrorItem<ILensBase>): IErrorDetail {
    return {
      itemName: LensErrorItem.item.name,
      itemUrl: null, // TODO: Have URL if the item exists.
      errorMessage: LensErrors.errorMessageFor(LensErrorItem)
    };
  }

  public static errorMessageFor(errorItem: IErrorItem<ILensBase>) {
    const lens = errorItem.item;
    const errorCode = errorItem.error.code;

    return ''; // TODO: Fill out error codes when they exist
  }
}
